import { render, staticRenderFns } from "./PopupSubTable.vue?vue&type=template&id=45273db8&scoped=true&"
import script from "./PopupSubTable.vue?vue&type=script&lang=js&"
export * from "./PopupSubTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45273db8",
  null
  
)

export default component.exports